import React, { ReactElement } from 'react';
import { Button, Modal, Tag } from 'antd';
import { isEmpty } from 'lodash';

import { TravelEligibility, TravelTypeIdType } from 'leash/types';
import { testId } from 'leash/utilities/test/dataTestId';

import { SeeEligiblePackagesModalContentList } from './SeeEligiblePackages.styles';

interface Props {
  travelEligibility: TravelEligibility[];
  travelTypeId: TravelTypeIdType;
}

function SeeEligiblePackages(props: Props): ReactElement {
  const { travelEligibility, travelTypeId } = props;
  const travelEligiblePackages = travelEligibility.filter(
    (eligibility) => eligibility.isEligible,
  );
  const eligibleTravelTypes = travelEligiblePackages.map((t) => t.travelType);
  const eligibleTravelTypesIds = eligibleTravelTypes.map((t) => t.id);
  const travelEligibilityPackages = eligibleTravelTypes.filter(
    ({ id }, index) => !eligibleTravelTypesIds.includes(id, index + 1),
  );

  const handleModalEligiblePackages = () => {
    Modal.info({
      title: 'Eligible',
      okText: 'Close',
      icon: false,
      autoFocusButton: null,
      content: (
        <SeeEligiblePackagesModalContentList
          data-testid={testId.seeEligiblePackagesModalContent}
        >
          {travelEligibilityPackages.map((travelType, idx) => (
            <li key={idx}>
              {travelType.name}
              {travelTypeId === travelType.id && <Tag color="success">Selected</Tag>}
            </li>
          ))}
        </SeeEligiblePackagesModalContentList>
      ),
    });
  };

  return (
    <Button
      type="link"
      onClick={handleModalEligiblePackages}
      disabled={isEmpty(travelEligibilityPackages)}
      data-testid={testId.seeEligiblePackagesBtn}
    >
      {isEmpty(travelEligibilityPackages)
        ? 'No Eligible Packages'
        : 'See All Eligible Packages'}
    </Button>
  );
}

export default SeeEligiblePackages;
